import {RootState} from "../../../../../../../app/store";
import {IntegrationFormSelectionProvider, IntegrationRequestPartial} from "../createAndUpdate/IntegrationForm";
import {Integration} from "../../../../../../../api/generated";

export const createIntegrationRequestPropertySelector = (rootSelector: (state: RootState) => IntegrationRequestPartial): IntegrationFormSelectionProvider => ({
    publicBotId(state: RootState): string | undefined {
        return rootSelector(state).publicBotId;
    },
    integration(state: RootState): Integration | undefined {
        return rootSelector(state).integration;
    },
    superchatApiKey(state: RootState): string | undefined {
        return rootSelector(state).superchatApiKey;
    },
    superchatAimeUserEmail(state: RootState): string | undefined {
        return rootSelector(state).superchatAimeUserEmail;
    },
    superchatHandoverUserEmailList(state: RootState): string | undefined {
        return rootSelector(state).superchatHandoverUserEmailList;
    },
});
